export default {
  pageKey: 0,
  modalShowing: false,
  modalContent: null,
  pageName: 'Home'
}
